export class NumberUtils {
    static isNumeric(val) {
        return !Array.isArray(val) && (val - parseFloat(val) + 1) >= 0;
    }
}
